import { render, staticRenderFns } from "./TournamentDealers.vue?vue&type=template&id=0cdeadc0"
import script from "./TournamentDealers.vue?vue&type=script&lang=js"
export * from "./TournamentDealers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports